import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import { CONTACT_QUERY } from '../graphql/Contact'
import CentredLoader from '../components/CentredLoader'
import { LEGAL_FORMALITIES_QUERY } from '../graphql/LegalFormalities'
import { LegalFormalityType } from '../types'

export const LegalFormalitiesContext = createContext({} as any)

interface Iprops {
  contactId: number
  children: any
}
const LegalFormalitiesContextProvider = (props: Iprops) => {
  const { contactId } = props
  const { data, loading } = useQuery(LEGAL_FORMALITIES_QUERY, {
    variables: { contactId: contactId },
  })

  if (loading) {
    return <CentredLoader />
  }

  const LAST_STATUSES = ['formality_done', 'flow_aborted', 'waiting']
  const formalities: LegalFormalityType[] = [
    ...(data.legalFormalities || []),
  ].sort((a: LegalFormalityType, b: LegalFormalityType) => {
    const aLast = LAST_STATUSES.includes(a.status) ? 1 : 0
    const bLast = LAST_STATUSES.includes(b.status) ? 1 : 0
    return aLast - bLast
  })

  return (
    <LegalFormalitiesContext.Provider value={{ legalFormalities: formalities }}>
      {props.children}
    </LegalFormalitiesContext.Provider>
  )
}

export default LegalFormalitiesContextProvider
